<template>
  <div>
    <b-container>
      <div v-if="currentUser">
        <h2 class="my-5">{{ $t('home.userWorkshops.title') }}</h2>

        <b-row align="center" class="mt-5" v-if="0 < currentUserWorkshops.length">
          <b-col cols="12" xl="4" lg="4" md="6" sm="6" xs="12"
            v-for="workshop in currentUserWorkshops"
            :key="workshop.uuid"
            class="mb-4">
            <WorkshopsCard :workshop="workshop" :with-register="false" :with-cancel="true" />
          </b-col>
        </b-row>
        <b-alert show variant="warning" v-else>
          {{ $t('home.userWorkshops.noWorkshop') }}
        </b-alert>
      </div>
    </b-container>
  </div>
</template>

<script>
  import { userEventBus } from '../../events/bus'
  import ApiService from '../../services/api'

  import WorkshopsCard from '../Workshops/Card'

  export default {
    components: {
      WorkshopsCard,
    },

    mounted() {
      if (!this.$store.state.userToken) {
        return this.$router.push({ name: 'home', query: this.$route.query })
      }

      userEventBus.$on('user.logged', () => {
        ApiService.getCurrentUserWorkshops()
          .then(response => {
            this.$store.dispatch('setUserWorkshops', response.data)
          })
      })
    },

    computed: {
      currentUser() {
        return this.$store.state.user
      },
      currentUserWorkshops() {
        return this.$store.state.userWorkshops
      },
    },
  }
</script>
